/**
 * Lenis Smooth Scrolling
 * ==========================================
 * Initializes Lenis for smooth, performant scroll experience
 * https://github.com/studio-freight/lenis
 */

import Lenis from 'lenis';

export function initLenis() {
	// Create Lenis instance with smooth scrolling
	const lenis = new Lenis({
		duration: 1.2,           // Scroll duration in seconds
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // easeOutExpo
		direction: 'vertical',
		gestureDirection: 'vertical',
		smooth: true,
		smoothTouch: false,      // Disable on touch devices for better mobile experience
		touchMultiplier: 2,
	});

	// RAFLoop for smooth animation
	function raf(time) {
		lenis.raf(time);
		requestAnimationFrame(raf);
	}

	requestAnimationFrame(raf);

	return lenis;
}

// Initialize Lenis on page load
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		initLenis();
	});
} else {
	initLenis();
}

